import { type AuthProvider } from '@/features/iam/auth/AuthStore'
import { decodeTokenInfo, type TokenInfo } from '../token-info'

/**
 * Used a token inserted by E2E tests for authentication.
 */
export class MockTokenProvider implements AuthProvider {
  private _token: TokenInfo | null = null

  constructor(token: TokenInfo) {
    this._token = token
  }

  fetchTokenInfo(signal?: AbortSignal): Promise<TokenInfo | null> {
    signal?.throwIfAborted()
    return Promise.resolve(this._token)
  }

  callback(): Promise<string | null> {
    throw new Error('Mock provider does not support auth callback.')
  }

  redirectToLogin(): Promise<void> {
    throw new Error('Mock provider does not support login.')
  }

  redirectToSignup(): Promise<void> {
    throw new Error('Mock provider does not support signup.')
  }

  logout(): Promise<void> {
    this._token = null
    return Promise.resolve()
  }

  /**
   * Creates a {@link MockTokenProvider} by reading a token from local storage.
   * If no token is present, does not create the provider.
   */
  static maybeFromLocalStorage(): MockTokenProvider | null {
    const testToken = localStorage.getItem('mockjwt')
    if (!testToken) {
      return null
    }
    const decoded = decodeTokenInfo(testToken)
    if (decoded.issuer !== 'https://mock.taxfyle.auth0.com') {
      return null
    }

    return new MockTokenProvider(decoded)
  }
}
